//
//  I13VENTCHAUFFIOULI18n.js
//
//  Created by Sébastien Hecart on 2017-11-24 13:22:57 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

export default {
  I13VENTCHAUFFIOUL_SECTION_0_TITLE:
    'Calculez la taille de vos ventilations chaufferies fioul, et déterminez les dimensions en fonction de la forme géometrique souhaitée.',
  I13VENTCHAUFFIOUL_in_puissanceTotal: 'Puissance Total',
  I13VENTCHAUFFIOUL_res_VH: 'VH',
  I13VENTCHAUFFIOUL_res_VB: 'VB',
  I13VENTCHAUFFIOUL_SECTION_1_TITLE: 'Section ronde',
  I13VENTCHAUFFIOUL_res_diamVH: 'Diamètre VH',
  I13VENTCHAUFFIOUL_res_diamVB: 'Diamètre VB',
  I13VENTCHAUFFIOUL_SECTION_2_TITLE: 'Section carrée',
  I13VENTCHAUFFIOUL_res_longeurVH: 'Longueur VH',
  I13VENTCHAUFFIOUL_res_longeurVB: 'Longueur VB',
  I13VENTCHAUFFIOUL_SECTION_3_TITLE: 'Section rectangulaire',
  I13VENTCHAUFFIOUL_in_longeurVH: 'Longueur VH',
  I13VENTCHAUFFIOUL_res_hauteurVH: 'Hauteur VH',
  I13VENTCHAUFFIOUL_in_longeurVB: 'Longueur VB',
  I13VENTCHAUFFIOUL_res_largeurVB: 'Largeur VB'
}
